var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C17.3018 21.6 21.5999 17.3019 21.5999 12C21.5999 6.69807 17.3018 2.4 11.9999 2.4C6.69797 2.4 2.3999 6.69807 2.3999 12C2.3999 17.3019 6.69797 21.6 11.9999 21.6ZM12.9999 5.49981C12.9999 4.94752 12.5522 4.49981 11.9999 4.49981C11.4476 4.49981 10.9999 4.94752 10.9999 5.49981V10.9998L7.49995 10.9996C6.94766 10.9996 6.49993 11.4473 6.4999 11.9996C6.49988 12.5519 6.94757 12.9996 7.49986 12.9996L11.9999 12.9998C12.2651 12.9998 12.5194 12.8945 12.707 12.7069C12.8945 12.5194 12.9999 12.265 12.9999 11.9998V5.49981Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartClock);
export default __webpack_public_path__ + "static/media/start-clock.0781d3faee6adc7e097b8ace485802b8.svg";
export { ForwardRef as ReactComponent };